import {Api} from '../../api';
import {getAuthUserCompanyId} from './getAuthUserCompanyId';
import {getAuthUser} from './getAuthUser';

export const updateUserLastSignIn = async () => {
  const companyId = await getAuthUserCompanyId();
  const authId = getAuthUser()?.uid ?? '';

  if (!authId) {
    return;
  }

  try {
    await Api.user.updateLastSignIn(companyId, authId);
    await Api.user.updateUserPlatform(companyId, authId);
  } catch (error) {
    console.error('Error updating user tracking:', error);
  }
};

